import React from "react";
import { ClaimForm } from "./claim-form/ClaimForm";

export const ClientFormTab = () => {
  return (
    
    <ClaimForm />
  );
};
